// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".individual-button-settings-container [data-buttonsettingstoggle] {\n  border-color: transparent !important;\n  background-color: transparent !important;\n}\n\n.individual-button-settings-container [data-buttonsettingstoggle] > span {\n  border-top: 0 !important;\n}\n\n.individual-button-settings-container\n  [data-buttonsettingstoggle]\n  > span:first-child {\n  flex-direction: row-reverse !important;\n  padding: 0.25rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
